<template>
  <section id="intro">
    <div class="container">
      <div class="row">
        <div align="left" class="col-sm-12 col-md-8">
          <div class="intro-content box">
            <h2>More Info</h2>
          </div>
        </div>
      </div>
    </div>

    <carousel
      :nav="false"
      :dots="false"
      :items="1"
      :autoplay="true"
      :loop="true"
      id="intro-carousel"
      style="margin-top:-50px"
      :responsive="{ 0: { items: 1, nav: false }, 600: { items: 1, nav: false } }"
    >
      <img class="item" v-for="(image, i) in images" :key="i" :src="image.image" />
    </carousel>

    <div id="intro-carousel" class="owl-carousel"></div>
  </section>
</template>

<script>
/* eslint-disable */

import carousel from "vue-owl-carousel";
export default {
  components: {
    carousel,
  },
  props: {
    images: {},
  },
  created() {
    this.$emit("Loaded", true);
  },
};
</script>

<style lang="scss" scoped></style>
